import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import { wrapDisplayName } from 'recompose';
import { withRouter, withClient } from '@deerplusofficial/pos-hoc';
import {
  formatDiscount,
  getResult,
  createCancelToken,
} from '@deerplusofficial/pos-helper';

export const refactorItem = ({
  dimension_name_1,
  dimension_name_2,
  dimension_name_3,
  dimension_1,
  dimension_2,
  dimension_3,
  quantity,
  discounts: itemDiscounts,
  ...props
}) => {
  const specs = _.omit(
    {
      [dimension_name_1]: dimension_1,
      [dimension_name_2]: dimension_2,
      [dimension_name_3]: dimension_3,
    },
    [null, 'undefined']
  );

  return {
    specs,
    discounts: formatDiscount(itemDiscounts),
    storage: quantity,
    ...props,
  };
};

const refactorItems = fp.map(refactorItem);

export default () => Component =>
  fp.compose(
    withRouter(),
    withClient()
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryProduct');

      static propTypes = {
        productId: PropTypes.string,
      };

      static defaultProps = {
        productId: '',
      };

      state = {
        product: {},
      };

      componentDidMount() {
        this.onFetch();
      }

      componentWillUnmount() {
        !_.isUndefined(this.cancelFetch) && this.cancelFetch();
      }

      onFetch = async () => {
        const {
          channelId,
          productId,
          client: { onError, POSApi },
        } = this.props;

        if (fp.size(productId) === 0) return;

        try {
          const {
            product_items,
            discounts,
            meta: { name, ...specs },
          } = getResult(
            await POSApi.get(
              `/pos/channels/${channelId}/products/${productId}/product_items`,
              { cancelToken: createCancelToken(this.cancelFetch) }
            )
          );
          const items = refactorItems(product_items);
          const product = {
            name,
            items,
            specs,
            discounts: formatDiscount(discounts),
          };

          this.setState({ product });
        } catch (e) {
          onError(e);
        }
      };

      render() {
        return (
          <Component
            onProductFetch={this.onFetch}
            {...this.state}
            {...this.props}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryProduct.js